// Safety net for icon markup this codebase does not control.
//
// The icon sprite is an external file, so a reference has to be a full URL - "#icon" on its own
// now points at a sprite that is not in the document. Markup we render is handled server-side by
// SvgSpriteUseTagHelper, and our own JavaScript uses spriteHref(). Third-party injected markup is
// the gap: Convert Experiments A/B variants are authored in their dashboard against the old
// inline-sprite convention, so a running variant can drop a bare "#icon" into the page and the
// icon silently renders blank.
//
// This repairs those as they arrive. The observer is deliberately permanent rather than on a
// timer: variants can apply late, and an expiring net would fail silently, which is the exact
// problem it exists to prevent. The cost is a short loop over added nodes, only when nodes are
// added, which is nothing next to the ~214kb per page the external sprite saves.

function getSpriteUrl() {
    return document.documentElement.getAttribute('data-svg-sprite') || '';
}

function repairUseElement(useElement, spriteUrl) {
    const href = useElement.getAttribute('href');
    const xlinkHref = useElement.getAttribute('xlink:href');

    if (href && href.charAt(0) === '#') {
        useElement.setAttribute('href', spriteUrl + href);
    }

    if (xlinkHref && xlinkHref.charAt(0) === '#') {
        useElement.setAttribute('xlink:href', spriteUrl + xlinkHref);
    }

    // An external reference needs the modern href; xlink:href alone will not resolve.
    if (!useElement.getAttribute('href') && useElement.getAttribute('xlink:href')) {
        useElement.setAttribute('href', useElement.getAttribute('xlink:href'));
    }
}

export function repairSpriteRefs(root) {
    const spriteUrl = getSpriteUrl();
    if (!spriteUrl) {
        return;
    }

    const scope = root || document;

    if (scope.tagName === 'use') {
        repairUseElement(scope, spriteUrl);
        return;
    }

    if (!scope.getElementsByTagName) {
        return;
    }

    const useElements = scope.getElementsByTagName('use');
    for (let i = 0; i < useElements.length; i++) {
        repairUseElement(useElements[i], spriteUrl);
    }
}

export default function SpriteRefs() {
    if (!getSpriteUrl()) {
        return;
    }

    // Anything a variant injected before this ran.
    repairSpriteRefs(document);

    if (!('MutationObserver' in window)) {
        return;
    }

    const observer = new MutationObserver((records) => {
        for (let r = 0; r < records.length; r++) {
            const added = records[r].addedNodes;
            for (let n = 0; n < added.length; n++) {
                const node = added[n];
                // Element nodes only; text and comment nodes cannot hold icons.
                if (node.nodeType === 1) {
                    repairSpriteRefs(node);
                }
            }
        }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
}
